// const { $ } = require("video.js/dist/types/utils/dom");
var isRTL = $("html").attr("dir") == "rtl" ? true : false,
  winWidth = $(window).width(),
  winHeight = $(window).height();
const vpMobile600 = 600;
const vpTablet767 = 767;
const vpTablet991 = 991;
const vpTablet1200 = 1200;
const black_color = '#221F20';
const white_color = '#FFFFFF';
const send1_color = '#DCD4C9';

const isPortrait = window.innerHeight > window.innerWidth;



$(function () {
  browserDetect();
});

$(window).on("resize orientationchange", function () {
  // Do on resize
  (winWidth = $(window).width()), (winHeight = $(window).height());
});

$(window).on("scroll", function () {
  //Do on Scroll

});
$(window).on("load", function () {
  $('html, body').animate({ scrollTop: -1 });
  scrollToTopOnLoad()
  getComponents()
  handleResizeChange()
  removeTimelineOnFooter()
  scrollbarInit()
  imgRespChange();
});



// Theme Changer
const changeTheme = () => {
  const themeChangingElem = document.querySelectorAll('.js-theme-changer')

  if (localStorage.getItem('isThemeDark') == "true") {
    document.body.classList.add('dark-theme');
    document.body.classList.remove('light-theme');
  } else {
    document.body.classList.add('light-theme');
    document.body.classList.remove('dark-theme');
  }

  themeChangingElem && themeChangingElem.length > 0 && themeChangingElem.forEach(elem => {
    elem.addEventListener('click', () => {
      if (document.body.classList.contains('light-theme')) {
        document.body.classList.remove('light-theme');
        document.body.classList.add('dark-theme');
        localStorage.setItem('isThemeDark', 'true');
      } else {
        document.body.classList.remove('dark-theme');
        document.body.classList.add('light-theme');
        localStorage.setItem('isThemeDark', 'false');
      }
    })
  })
}


function imgRespChange() {
  const imgs = document.querySelectorAll('.js-image-mobile-change');

  imgs.forEach(img => {
    const imgMobSrc = img.getAttribute('data-mob-src');

    if (imgMobSrc && window.matchMedia('(max-width: 768px)').matches) {
      img.src = imgMobSrc;
    }
  });
}

function scrollbarInit() {

  var customScrollbars = document.querySelectorAll('.custom-scrollbar');
  customScrollbars.forEach(cSbar => {
    var ps = new PerfectScrollbar(cSbar, {
      wheelSpeed: 1,
      wheelPropagation: true,
      minScrollbarLength: 10,
      swipeEasing: true,
    });
  })
}

function getComponents() {
  const allSections = document.querySelectorAll('.js-impact-section, .js-statement-section, .js-statement-section-alt, .js-statement-section-alt-business, .js-section-timeline-scroll-main, .gen-statement, .gen-statement2');

  allSections.forEach((section, i) => {
    if (section.classList.contains('js-impact-section')) {
      impactSectionAnimation(section)
    } else if (section.classList.contains('js-statement-section')) {
      statementSectionAnim(section, i)
    } else if (section.classList.contains('js-statement-section-alt')) {
      statementSectionAltAnim(section)

    } else if (section.classList.contains('js-statement-section-alt-business')) {
      statementSectionBusinessAltAnim(section)
    }
    else if (section.classList.contains('js-section-timeline-scroll-main')) {
      sectionTimelineScroll()
    } else if (section.classList.contains('gen-statement')) {
      generalHorizontalSection('.gen-statement');
    }
    else if (section.classList.contains('gen-statement2')) {
      generalHorizontalSection('.gen-statement2');
    }

  });
  jsAnimFade()
  textUpAnimations()
  footerAnimation()
  changeBgColorStatementSectionsMob();
  // changeBgHorizontal();
  impactNumbersAnimation()
  statementDrawerHeaderScroll()
  fadeOutOnScrollUp()
}


function browserDetect() {
  navigator.sayswho = (function () {
    var ua = navigator.userAgent,
      tem,
      M =
        ua.match(
          /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
        ) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join("").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M.join(" ");
  })();
  $("body").addClass(navigator.sayswho);
}

function arabicDigitsEn() {

  setTimeout(() => {
    if ($("html").attr("dir") === "rtl") {
      $('*').contents().filter(function () {
        return this.nodeType === 3 && /\d/.test(this.nodeValue); // Select text nodes that contain digits
      }).each(function () {
        var newHtml = $(this).text().replace(/(\d+)/g, '<span class="digitEn">$1</span>'); // Wrap digits in <span>
        $(this).replaceWith(newHtml); // Replace the original text node with the new HTML
      });
    }
  }, 800);

}
// When document ready (loader initiates)
$(document).ready(function () {
  videoPlayerInit();
  loader();
  dataTrim();
  ChangeToSvg();
  formValidation();
  landingAnimation();
  scrollToTopOnLoad()
  checkActiveLanguage(); // Check which language is active
  scrollTop(); // Footer scroll to top button
  openAndCloseStatmentDrawer();
  addNavLinksEvents()
  onClickMobileMenu()
  // lazyLoadingFunc();
  readMoreBtn();
  // loadVideoLazy();
  arabicDigitsEn();
  changeTheme()



});



if (window.matchMedia(`(min-width: ${vpTablet1200}px)`).matches) {
  ScrollTrigger.normalizeScroll(true);
  ScrollSmoother.create({
    smooth: 0.4,
    speed: 1,
    type: "touch,wheel,pointer",

  });
}


let intersectingSection;


function dataTrim() {
  var ellipsis = "...";
  $("[data-trim]").each(function () {
    var text = $(this).html();
    var charLimit = parseInt($(this).attr("data-trim"));
    $(this).html(TrimLength(text, charLimit));
    $(this).addClass("is--trimmed");
  });

  function TrimLength(text, maxLength) {
    text = $.trim(text);
    if (text.length > maxLength) {
      text = text.substring(0, maxLength - ellipsis.length);
      return text.substring(0, text.lastIndexOf(" ")) + ellipsis;
    } else return text;
  }
}


function fadeOutOnScrollUp() {
  const fadeOutSections = document.querySelectorAll('.js-fade-out-on-scroll-up')

  fadeOutSections.forEach(fadeOutSection => {
    let mm = gsap.matchMedia()

    mm.add(`(min-width: ${vpTablet767}px)`, () => {

      const tl = gsap.timeline({
        scrollTrigger: {
          start: 'bottom top+=253',
          end: "bottom top",
          trigger: fadeOutSection,
          toggleActions: 'play reverse play reverse',
        }
      })

      tl.fromTo(fadeOutSection, {
        opacity: 1
      }, {
        opacity: 0.5
      })
    })

  })
}

function ChangeToSvg() {
  $("img.js-tosvg").each(function () {
    var $img = $(this);
    var imgID = $img.attr("id");
    var imgClass = $img.attr("class");
    var imgURL = $img.attr("src");
    $.get(
      imgURL,
      function (data) {
        var $svg = $(data).find("svg");
        if (typeof imgID !== "undefined") {
          $svg = $svg.attr("id", imgID);
        }
        if (typeof imgClass !== "undefined") {
          $svg = $svg.attr("class", imgClass + " insvg");
        }
        $svg = $svg.removeAttr("xmlns:a");
        if (
          !$svg.attr("viewBox") &&
          $svg.attr("height") &&
          $svg.attr("width")
        ) {
          $svg.attr(
            "viewBox",
            "0 0 " + $svg.attr("height") + " " + $svg.attr("width")
          );
        }
        $img.replaceWith($svg);
      },
      "xml"
    );
  });
}

// Handle resize Change

const handleResizeChange = () => {
  let initialWidth = window.innerWidth;

  function reloadWindow() {
    const newWidth = window.innerWidth;
    if (newWidth !== initialWidth) {
      window.location.reload();
    }
  }

  window.addEventListener('resize', reloadWindow);
};

// Footer Animations

function footerAnimation() {
  // js-section-timeline-wrapper
  const animContainerSections = document.querySelectorAll(".js-footer-wrapper");

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: '.js-footer-wrapper',
      start: window.matchMedia(`(min-width: ${vpTablet1200}px)`).matches ? 'top 70%' : 'top 80%',
    }
  });

  tl.from('.js-footer-desc-text', {
    opacity: 0,
    y: '40%',
    duration: 0.3,

  }).from('.js-decoration-container', {
    opacity: 0,
    duration: 0.2

  })
    .from('.js-copyright-text', {
      opacity: 0,
      duration: 0.2
    })
    .fromTo('.js-footer-link', {
      opacity: 0,
    }, {
      opacity: 1,
      stagger: 0.1
    }).from('.js-scroll-top-btn', {
      opacity: 0,
    })


  animContainerSections.forEach(animContainerSection => {
    const quoteTextContainers = animContainerSection.querySelectorAll(".js-anim-text-container");

    quoteTextContainers.forEach(quoteTextContainer => {
      if (quoteTextContainer) {

        const quoteTxt = quoteTextContainer?.querySelector(".js-anim-text-up")?.textContent?.trim();

        const quoteWords = quoteTxt && quoteTxt?.split(" ") || [];


        const tl = gsap.timeline({
          scrollTrigger: {
            start: "top 90%",
            trigger: animContainerSection,

          },

        });
        if (quoteWords && quoteWords.length > 0) {

          const skewY = '7deg';
          const translateY = '50%';

          quoteWords.forEach((word, index) => {
            const space = " ";
            const wordElement = document.createElement("span");
            wordElement.className = `quote-word word-${index}`;

            const wordChildElement = document.createElement("span");
            wordChildElement.className = `quote-word-child word-child-${index}`;
            wordChildElement.textContent = word;
            wordElement.appendChild(wordChildElement)

            if (index != 0) {
              const wordChildElementSpace = document.createElement("span");
              wordChildElementSpace.className = `space`;
              wordChildElementSpace.textContent = space;

              quoteTextContainer.appendChild(wordChildElementSpace)
            }
            quoteTextContainer.appendChild(wordElement);

            tl.fromTo(
              wordChildElement,
              {
                opacity: 0,
                translateY: translateY,
                skewY: skewY,
                display: 'inline-block',
              },
              {
                duration: () => 0.3,
                ease: "powe4.Out",
                opacity: 1,
                translateY: '0%',
                skewY: '0deg',
              }, '-=0.2'
            );
          });
        }
      }

    })

  })


}

// Statement Drawer Header Scroll functionality
function statementDrawerHeaderScroll() {
  const statementDrawers = document.querySelectorAll(".js-statement-drawer")

  statementDrawers.forEach(statementDrawer => {
    const drawer = statementDrawer.querySelector('.js-drawer')

    drawer?.addEventListener('scroll', () => {
      const drawerContent = statementDrawer.querySelector('.js-drawer-content')
      const drawerHeader = statementDrawer.querySelector('.js-drawer-header')

      if (drawerContent.getBoundingClientRect().top < -100) {
        drawerHeader?.classList.add('drawer-header--down')
      } else {
        drawerHeader?.classList.remove('drawer-header--down')

      }

    })

  })
}

// Change bg color when image appears on mobile



function changeBgColorStatementSectionsMob() {
  if (window.matchMedia(`(max-width: ${vpTablet767}px)`).matches) {
    window.addEventListener('scroll', () => {
      const sections = document.querySelectorAll('.js-statement-section, .js-statement-section-alt, .general-horizontal, .general-horizontal-strategic');

      sections.forEach((section) => {
        let imgElement;

        if (section.classList.contains('js-statement-section') || section.classList.contains('js-statement-section-alt')) {
          imgElement = section.querySelector('.js-statement-section-flex-left-img');
        } else if (section.classList.contains('general-horizontal') || section.classList.contains('general-horizontal-strategic')) {
          imgElement = section.querySelector('.personProfile');
        }

        if (imgElement) {
          const sectionRect = section.getBoundingClientRect();
          const imgRect = imgElement.getBoundingClientRect();
          const windowMidHeight = window.innerHeight / 2;

          if (sectionRect.top < window.innerHeight && sectionRect.bottom > 0) {
            if (imgRect.top < windowMidHeight) {
              document.body.classList.add('bgWhite');
            } else {
              document.body.classList.remove('bgWhite');
            }
          }
          // else {
          //   document.body.classList.remove('bgWhite');
          // }
        }
      });
    });
  }
}



// function changeBgHorizontal() {
//   const $sections = $('.general-horizontal, .general-horizontal-strategic');

//   const textBaseDetail = document.querySelector('.textBaseDetail');

//   if (textBaseDetail) {
//     ScrollTrigger.create({
//       trigger: textBaseDetail,
//       start: 'top center', // Adjust the start point as needed
//       end: 'bottom center', // Adjust the end point as needed
//       onEnter: () => {
//         document.body.classList.add('bgWhite');
//       },
//       onLeaveBack: () => {
//         document.body.classList.remove('bgWhite');
//       },
//       onLeave: () => {
//         document.body.classList.remove('bgWhite');
//       },
//       onEnterBack: () => {
//         document.body.classList.add('bgWhite');
//       },
//       toggleActions: "play none none reverse"
//     });
//   }
// }




// Impact numbers slide animation
function impactNumbersAnimation() {
  // if (window.matchMedia(`(min-width: ${vpTablet767}px)`).matches) {

  const impactWrappers = document.querySelectorAll('.js-impact-wrapper')

  impactWrappers.forEach((impactWrapper, i) => {



    const statFigures = impactWrapper.querySelectorAll('.js-stat-figure')

    statFigures.forEach(stat => {
      if (stat) {

        const statOriginalValue = stat.getAttribute('data-original-value');
        const statStartValue = stat.getAttribute('data-start-value');
        const statEndValue = stat.getAttribute('data-end-value');

        if (!statOriginalValue) return;
        const mainSpan = document.createElement('span')
        const innerSpansContainer = document.createElement('span')
        innerSpansContainer.classList.add('inner-spans')
        mainSpan.classList.add('stat-figures-main-span')
        if (Number.isInteger(+statOriginalValue)) {
          if (stat.getAttribute('data-spans-created') !== 'true') {
            const statOriginalValueArray =
              Array.from(String(statOriginalValue), Number);
            const numbersArray = [`${statStartValue}`, ...statOriginalValueArray, `${statEndValue}`];

            numbersArray.map((numberArray, i) => {
              if (i === 0 && numberArray === statStartValue || i === numbersArray.length - 1 && numberArray === statEndValue) {
                if (i === 0 && numberArray === statStartValue) {
                  const startSpan = document.createElement('span')
                  startSpan.className = 'stat-start-value'
                  startSpan.innerHTML = `<small>${numberArray}</small>`
                  mainSpan.appendChild(startSpan)
                } else {
                  const endSpan = document.createElement('span')
                  endSpan.className = 'stat-end-value'
                  endSpan.innerHTML = `<small>${numberArray}</small>`
                  mainSpan.appendChild(endSpan)
                }
              } else {
                const statFigureElement = document.createElement('span');
                statFigureElement.className = 'js-stat-figure-container stat-figure-container';

                let spanContent = '';
                if (numberArray === 0) {
                  spanContent += `${0}<br>`;
                } else {
                  for (let i = 1; i <= +numberArray; i++) {
                    spanContent += `${i}<br>`;
                  }
                }

                spanContent = spanContent.slice(0, -4);

                statFigureElement.innerHTML = spanContent;
                mainSpan.appendChild(statFigureElement);
              }

            });
            stat.appendChild(mainSpan);
            stat.setAttribute('data-spans-created', 'true')
          }
          window.addEventListener('scroll', () => {

            const impactWrapperTop = impactWrapper.getBoundingClientRect().top;
            if (impactWrapperTop < 50) {
              const statFiguresContainer = impactWrapper.querySelectorAll('.js-stat-figure-container')

              statFiguresContainer.forEach(statFigureCont => {

                const statFigureContent = statFigureCont.innerHTML;

                let spansCount = statFigureContent.split("<br>").length


                const statFigureContHeight = statFigureCont.clientHeight
                const heightOfOne = statFigureContHeight / spansCount;

                if (statFigureCont.getAttribute('data-animated') === 'true') return;
                gsap.fromTo(
                  statFigureCont,
                  {
                    y: '0',
                  },
                  {
                    y: `-${heightOfOne * (spansCount - 1)}px`,
                    duration: 1.5,
                    onStart: () => {
                      statFigureCont.setAttribute('data-animated', 'true');

                    }
                  }
                );


              })
            }
          })

        }
        else {
          if (stat.getAttribute('data-spans-created') !== 'true') {


            const [integerPart, decimalPart] = statOriginalValue.split('.');

            // Convert integerPart and decimalPart to arrays of numbers
            const integerArray = Array.from(String(integerPart), Number);
            const decimalArray = Array.from(String(decimalPart), Number);

            // Combine both arrays
            const concatDecimal = integerArray.concat('.', decimalArray);

            const numbersArray = [`${statStartValue}`, ...concatDecimal, `${statEndValue}`];

            numbersArray.map((numberArray, i) => {
              if (numberArray == '.' || i === 0 && numberArray === statStartValue || i === numbersArray.length - 1 && numberArray === statEndValue) {
                if (numberArray == '.') {
                  const decimalSpan = document.createElement('span')
                  decimalSpan.className = 'js-stat-figure-decimal stat-figure-decimal'
                  decimalSpan.innerHTML = numberArray
                  mainSpan.appendChild(decimalSpan)
                }
                if (i === 0 && numberArray === statStartValue) {
                  const startSpan = document.createElement('span')
                  startSpan.className = 'stat-start-value'
                  startSpan.innerHTML = `<small>${numberArray}</small>`
                  mainSpan.appendChild(startSpan)
                }
                if (i === numbersArray.length - 1 && numberArray === statEndValue) {
                  const endSpan = document.createElement('span')
                  endSpan.className = 'stat-end-value'
                  endSpan.innerHTML = `<small>${numberArray}</small>`
                  mainSpan.appendChild(endSpan)
                }
              } else {

                const statFigureElement = document.createElement('span');
                statFigureElement.className = 'js-stat-figure-container stat-figure-container';

                let spanContent = '';
                for (let i = 1; i <= +numberArray; i++) {
                  spanContent += `${i}<br>`;
                }

                spanContent = spanContent.slice(0, -4);

                statFigureElement.innerHTML = spanContent;

                mainSpan.appendChild(statFigureElement);
              }
            });
            stat.appendChild(mainSpan);
            stat.setAttribute('data-spans-created', 'true')

          }
          window.addEventListener('scroll', () => {
            const impactWrapperTop = impactWrapper.getBoundingClientRect().top;
            if (impactWrapperTop < 50) {
              const statFiguresContainer = impactWrapper.querySelectorAll('.js-stat-figure-container')
              statFiguresContainer.forEach(statFigureCont => {

                const statFigureContent = statFigureCont.innerHTML;

                let spansCount = statFigureContent.split("<br>").length


                const statFigureContHeight = statFigureCont.clientHeight
                const heightOfOne = statFigureContHeight / spansCount;
                if (statFigureCont.getAttribute('data-animated') === 'true') return;

                gsap.fromTo(
                  statFigureCont,
                  {
                    y: '0',
                  },
                  {
                    y: `-${heightOfOne * (spansCount - 1)}px`,
                    duration: 1.5,
                    onStart: () => {
                      statFigureCont.setAttribute('data-animated', 'true');

                    }
                  }
                );



              })
            }
          })
        }


      }


    })


  })
  // }

}

// Text Up Animations
function textUpAnimations() {
  const animContainerSections = document.querySelectorAll(".js-anim-container-section");

  animContainerSections.forEach(animContainerSection => {
    const quoteTextContainers = animContainerSection.querySelectorAll(".js-anim-text-container");
    quoteTextContainers.forEach(quoteTextContainer => {
      const quoteTxt = quoteTextContainer?.querySelector(".js-anim-text-up")?.textContent?.trim();
      const quoteWords = quoteTxt?.split(" ") || [];


      const tl = gsap.timeline({
        scrollTrigger: {
          start: 'top 20%',
          trigger: animContainerSection,
        },

      });

      const skewY = '7deg';
      const translateY = '50%';

      quoteWords.forEach((word, index) => {
        const space = " ";
        const wordElement = document.createElement("span");
        wordElement.className = `quote-word word-${index}`;

        const wordChildElement = document.createElement("span");
        wordChildElement.className = `quote-word-child word-child-${index}`;
        wordChildElement.textContent = word;
        wordElement.appendChild(wordChildElement)

        if (index != 0) {
          const wordChildElementSpace = document.createElement("span");
          wordChildElementSpace.className = `space`;
          wordChildElementSpace.textContent = space;

          quoteTextContainer.appendChild(wordChildElementSpace)
        }
        quoteTextContainer.appendChild(wordElement);

        tl.fromTo(
          wordChildElement,
          {
            opacity: 0,
            translateY: translateY,
            skewY: skewY,
            display: 'inline-block',
          },
          {
            duration: () => 0.3,
            ease: "powe4.Out",
            opacity: 1,
            translateY: '0%',
            skewY: '0deg',
          }, '-=0.15'
        );
      });
    })
  })
}

// Form Field Validation Start
function formValidation() {
  const submitBtn = document.querySelectorAll(".Formsubmit");

  // Loop through each submit button
  submitBtn.forEach(function (button) {
    button.addEventListener("click", function (event) {
      var form = event.target.closest("form"); // Get the parent form of the clicked button
      var isValid = true;

      $(form)
        .find(".form-row-dropdown, .form-fields-row")
        .each(function () {
          var $select = $(this).find("select");
          var $errorMessage = $(this).find(".error");
          var $select2Container = $(this).find(".select2-container");

          if ($select.val() == null || $select.val() == "1") {
            isValid = false;
            $select2Container.addClass("error-border");
            $errorMessage.show();
          } else {
            $select2Container.removeClass("error-border");
            $errorMessage.hide();
          }
        });

      // Check input fields with the required class within the current form
      $(form)
        .find(".required")
        .each(function () {
          if ($(this).val().trim() === "") {
            isValid = false;
            $(this).addClass("error-border");
            $(this).siblings(".error").show();
          } else {
            $(this).removeClass("error-border");
            $(this).siblings(".error").hide();
          }
        });

      if (!isValid) {
        event.preventDefault(); // Prevent form submission if validation fails
      }
    });
  });

  //
  var togglePasswordIcons = document.querySelectorAll(".eye-icon");
  var togglePasswordSlashIcons = document.querySelectorAll(".eye-slash-icon");

  togglePasswordIcons.forEach(function (icon) {
    icon.addEventListener("click", function () {
      togglePasswordVisibility(icon);
    });
  });

  togglePasswordSlashIcons.forEach(function (Slashicon) {
    Slashicon.addEventListener("click", function () {
      togglePasswordVisibility(Slashicon);
    });
  });

  function togglePasswordVisibility(clickedIcon) {
    var passwordField = clickedIcon.parentNode.querySelector(".password-field");
    var relatedIcon = clickedIcon.classList.contains("eye-icon")
      ? clickedIcon.nextElementSibling
      : clickedIcon.previousElementSibling;

    if (passwordField.type === "password") {
      passwordField.type = "text";
      clickedIcon.style.display = "none";
      relatedIcon.style.display = "block";
    } else {
      passwordField.type = "password";
      clickedIcon.style.display = "none";
      relatedIcon.style.display = "block";
    }
  }
}

// Video Player Init
function videoPlayerInit() {
  $(".my-video-js").each(function (index) {
    var thisId = $(this).attr("id");
    $(this).addClass("video-js");
    if (!thisId == "") {
      thisId = "video-id-" + index;
      $(this).attr("id", thisId);
    }
    var player = videojs(thisId);
  });
}

// Function to convert a given value to rem
function toRem(value) {
  let baseFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
  return value * baseFontSize;
}

// Initialize Loader
let loaderAnimCompletes = false;
function loader() {
  if ($('.js-loader-container').length === 0) { return }; // If loader container doesn't exist, don't initiate loader
  const herobgimgContainer = document.querySelector('.js-hero-bg-img-container');
  window.scrollTo(0, 0);
  $('html, body').animate({ scrollTop: -1 }, 'slow');
  const shapesTl = gsap.timeline({ repeat: -1, yoyo: true });
  const expandTl = gsap.timeline({ paused: true });
  const isLandScapeScreen = winHeight > winWidth ? winHeight : winWidth;
  let extraWidthToRem = toRem(28.125)

  let mm = gsap.matchMedia();
  gsap.set('.js-nav-section', { zIndex: 9999 })

  mm.add(`(max-width: ${vpMobile600}px)`, () => { //vpMobile600
    expandTl.to(".js-loader-container .js-shape-2", {
      duration: 1,
      delay: 0.4,
      rotate: "20deg",
      width: `${isLandScapeScreen + 450}px`,
      height: `${isLandScapeScreen + 450}px`,
      position: 'fixed',
      onStart: () => {
        gsap.to('.js-loader-container .shape-2', { duration: 0, borderColor: 'transaprent' })
        gsap.set(".js-loader-container .js-shape-1, .js-loader-container .js-shape-3", { opacity: 0, display: 'none' })
      },
      ontimeupdate: () => {
        gsap.to('.js-loader-container .shape-2', { duration: 0.4, borderWidth: '0px', })
        gsap.to(".js-loader-container .js-shape-2 .js-hero-banner", { delay: 0.2, rotate: "-20deg" })
        gsap.fromTo(".js-loader-container .js-shape-2 .js-hero-banner", { opacity: 0, width: `${isLandScapeScreen + 450}px`, height: `${isLandScapeScreen + 450}px` }, { delay: 0.1, duration: 0.9, width: '100vw', height: '100vh', opacity: 1, position: 'absolute' })
      },
    })
      .to(
        ".js-loader-container",
        {
          duration: 0.2,
          onComplete: () => {
            gsap.set(".js-loader-container", { position: "absolute", zIndex: 0 });
            gsap.set('.js-nav-section', { zIndex: 0 })
            gsap.set('.js-loader-container .shape-2', { position: 'absolute' })
            $("body").removeClass("scrollHide");
          }
        },
        "-=0.2"
      )
      .from('.js-icon-logo', {
        opacity: 0
      }, '-=0.2')
      .fromTo('.js-menu-icon', {
        opacity: 0
      }, {
        opacity: 1
      }, '<')
      .from('.js-hero-title-text', {
        y: "100%",
        opacity: 0,
        duration: 0.3
      })
      .from('.js-hero-description-text', {
        y: '80%',
        opacity: 0,
        duration: 0.3

      })
      .from('.js-hero-btn-anim', {
        y: '80%',
        opacity: 0,
        duration: 0.3

      })
      .to(
        ".js-hero-wrapper .js-hero-right-img",
        {
          // bottom: "-6.125rem",
          [isRTL ? "left" : "right"]: "0",
          //  y: "100vh",
          onComplete: () => loaderAnimCompletes = true
        }
      )

      ;
  });

  mm.add(`(min-width: ${vpMobile600 + 1}px)`, () => {
    expandTl.to(".js-loader-container .js-shape-2", {
      duration: 1,
      delay: 0.4,
      rotate: "20deg",
      width: `${isLandScapeScreen + 650}px`,
      height: `${isLandScapeScreen + 650}px`,
      position: 'fixed',
      onStart: () => {
        gsap.to('.js-loader-container .shape-2', { duration: 0, borderColor: 'transaprent' })
        gsap.set(".js-loader-container .js-shape-1, .js-loader-container .js-shape-3", { opacity: 0, display: 'none' })
      },
      ontimeupdate: () => {
        gsap.to('.js-loader-container .shape-2', { duration: 0.4, borderWidth: '0px', })
        gsap.to(".js-loader-container .js-shape-2 .js-hero-banner", { delay: 0.2, rotate: "-20deg" })
        gsap.fromTo(".js-loader-container .js-shape-2 .js-hero-banner", { opacity: 0, width: `${isLandScapeScreen + 650}px`, height: `${isLandScapeScreen + 650}px` }, { delay: 0.1, duration: 0.9, width: '100vw', height: '100vh', opacity: 1, position: 'absolute' })
      },
    })
      .to(
        ".js-loader-container",
        {
          duration: 0.2,
          onComplete: () => {
            gsap.set(".js-loader-container", { position: "absolute", zIndex: 0 });
            gsap.set('.js-nav-section', { zIndex: 0 })
            gsap.set('.js-loader-container .shape-2', { position: 'absolute' })

            $("body").removeClass("scrollHide");
          },
        },
        "-=0.2"
      )
      .fromTo('.header-wrapper', {
        y: '-30vh',
        duration: .1,
      },
        {
          y: "0"
        })
      .from('.js-hero-title-text', {
        y: "100%",
        opacity: 0,
        duration: 0.3
      })
      .from('.js-hero-description-text', {
        y: '80%',
        opacity: 0,
        duration: 0.3

      })
      .from('.js-hero-btn-anim', {
        y: '80%',
        opacity: 0,
        duration: 0.3

      })
    if (herobgimgContainer) {
      expandTl.from('.js-hero-bg-img-container', {
        scale: 1.3
      }, '-=0.1')
    }

    expandTl.to('.js-section-timeline-wrapper', { opacity: 1, duration: .1, onComplete: () => loaderAnimCompletes = true })
      // .fromTo('.header-wrapper',{
      //   y: '-30vh',
      //   duration: .1,
      // },
      // {
      //   y: "0"
      // })
      // .from('.js-icon-logo, .js-header-right', {
      //   opacity: 0,

      // }, '-=0.1')



      // .from('.js-hero-title-text', {
      //   // y: '100vh',
      //   // y: '100%',
      //   opacity:0,
      //   duration: 1,

      //   onComplete: () => loaderAnimCompletes = true

      // }, '<')


      ;
  });
  mm.add(`(max-width: ${vpTablet991}px) and (min-width: ${vpTablet767 + 1}px)`, () => {
    expandTl.from('.hero-right-img.js-hero-right-img', {
      // opacity: 0,
      y: "100vh",
      duration: .3
    })
  })
  shapesTl
    .fromTo(
      ".js-loader-container .js-shape-1",
      { opacity: 0 },
      {
        duration: 0.5,
        opacity: 1,
        onStart: () => $("body").addClass("scrollHide"),
      }
    )
    .fromTo(
      ".js-loader-container .js-shape-2",
      { opacity: 0 },
      { duration: 0.5, opacity: 1 }
    )
    .fromTo(
      ".js-loader-container .js-shape-3",
      { opacity: 0 },
      {
        duration: 0.5,
        opacity: 1,
        onComplete: () => {
          if (document.readyState === "complete") {
            shapesTl.kill();
            expandTl.play();
          }
        },
      }
    )

    ;



}

// Header mobile menu
function onClickMobileMenu() {
  $('#js-menu-icon, .js-nav-item').on('click', function () {
    $("#js-menu-icon").css({ 'pointer-events': 'none' })
    const menuTl = gsap.timeline();
    $('#js-menu-icon').toggleClass('active');
    $('#js-mobile-menu').toggleClass('active');

    // When menu is clicked
    if ($('#js-menu-icon').hasClass('active') && $('#js-mobile-menu').hasClass('active')) {

      $('body').addClass('scrollHide'); // Body overflow hidden
      $('#js-header-wrapper').removeClass('dark')
      menuTl.set('#js-mobile-menu', { display: 'block' })
        .to('#js-mobile-menu', { duration: 0.5, opacity: 1, translateY: 0 })
        .to('#js-bar-1', { duration: 0.25, rotate: '-45deg', translateY: '200%' }, '<')
        .to('#js-bar-2', { duration: 0.25, rotate: '45deg', translateY: '-200%' }, '<')
        .fromTo('.js-nav-item', { opacity: 0, x: isRTL ? '10px' : '-10px' }, { opacity: 1, x: '0px', stagger: 0.1, onComplete: () => $("#js-menu-icon").css({ 'pointer-events': 'auto' }) }, "-=0.3");

    } else {
      $('body').removeClass('scrollHide'); // Body overflow auto
      $("#js-menu-icon").css({ 'pointer-events': 'none' })

      // When header-wrapper has class dark
      if ($(intersectingSection).hasClass('dark')) {
        $('#js-header-wrapper').addClass('dark')

        menuTl.to('#js-mobile-menu', { duration: 0.5, opacity: 0, translateY: '100%' })
          .to('#js-bar-1', { duration: 0.25, rotate: '0', translateY: '0' }, '<')
          .to('#js-bar-2', { duration: 0.25, rotate: '0', translateY: '0', }, '<')
          .set('#js-mobile-menu', { display: 'none', onComplete: () => $("#js-menu-icon").css({ 'pointer-events': 'auto' }) });

        gsap.set('.js-nav-item', { opacity: 0, x: '-10px' })
      } else { // When header-wrapper doesn't has class dark
        $('#js-header-wrapper').removeClass('dark')
        menuTl.to('#js-mobile-menu', { duration: 0.5, opacity: 0, translateY: '100%' })
          .to('#js-bar-1', { duration: 0.25, rotate: '0', translateY: '0' }, '<')
          .to('#js-bar-2', { duration: 0.25, rotate: '0', translateY: '0' }, '<')
          .set('#js-mobile-menu', { display: 'none', onComplete: () => $("#js-menu-icon").css({ 'pointer-events': 'auto' }) });
        gsap.set('.js-nav-item', { opacity: 0, x: '-10px' })
      }
    }
  })
}

// Landing Page
function landingAnimation() {
  // Landing Page timeline

  let mm = gsap.matchMedia();
  // let herobgimgContainer = document.querySelector('.js-hero-bg-img-container');


  mm.add(`(min-width: ${vpTablet991 + .98}px)`, () => {
    const initialScreenHeight = 1080;

    function adjustHeroScrollUp(currentScreenHeight) {
      if (window.matchMedia(`(max-width: ${vpTablet991}px)`).matches) {
        return (1000 / initialScreenHeight) * currentScreenHeight;

      } else {
        return (550 / initialScreenHeight) * currentScreenHeight;

      }
    }

    const currentScreenHeight = window.innerHeight;

    heroScrollUp = adjustHeroScrollUp(currentScreenHeight);

    const landingWrapper = document.querySelector(".js-hero-wrapper");
    const landingTl = gsap.timeline({
      scrollTrigger: {
        trigger: landingWrapper,
        pin: true,
        scrub: window.matchMedia(`(max-width: ${vpTablet991}px)`).matches ? 1 : 2
        ,
        end: "+=450%",  //before 80
        start: "top top",
        invalidateOnRefresh: true,
      }
    });


    // Parallax image

    // gsap.set(".js-hero-bg-img", {
    //   // width: "150%",
    //   // height: "150%"
    //   scale: 1.2
    // })

    // gsap.fromTo(
    //   ".js-hero-bg-img",
    //   { yPercent: 0, transformOrigin: "center" },
    //   {
    //     yPercent: -10,
    //     duration: 0.2,
    //     scrollTrigger: {
    //       trigger: ".js-hero-bg-img-container",
    //       start: "top top",
    //       scrub: 2,
    //     },
    //   }
    // );
    if (window.matchMedia(`(max-width: ${vpTablet991}px)`).matches) {
      landingTl
        .fromTo(
          ".js-hero-wrapper .js-hero-title",
          {
            scale: 1.6,
            transformOrigin: isRTL ? "right bottom" : "left bottom",
            y: "60vh",
          },
          {
            scale: 1,
            y: "30vh",
            duration: 0.3,
          }
        )
    } else if (window.matchMedia(`(min-width: ${vpTablet991 + 1}px)`).matches) {
      landingTl
        .fromTo(
          ".js-hero-wrapper .js-hero-title",
          {
            scale: 1.6,
            transformOrigin: isRTL ? "right bottom" : "left bottom",
            y: "50vh",
          },
          {
            scale: 1,
            y: "0vh",
            duration: 0.4,
          }
        )
    }

    landingTl.fromTo(
      ".js-hero-wrapper .hero-right-img.js-hero-right-img",
      {
        y: "100vh",
      },
      {
        y: "0vh",
      }, '<'
    )
      .fromTo(
        ".js-hero-wrapper .js-hero-description-scroll-cta",
        {
          y: "100vh",
        },
        {
          y: "20vh",
        }, '<'
      )
    // if(window.matchMedia(`(max-width: ${vpTablet991}px)`).matches){

    // landingTl.fromTo(
    //   ".js-hero-wrapper .js-hero-right-img",
    //   {
    //     scale: 1,
    //   },
    //   {
    //     marginTop: 0,

    //     scale: 1.7,
    //   }
    // }
    landingTl.to(
      ".js-hero-wrapper .js-hero-title",
      {
        // y: "-50vh",
      }, window.matchMedia(`(max-width: ${vpTablet991}px)`).matches ? '<' : ">"
    )
      .fromTo(
        ".js-hero-wrapper .js-hero-description-text",
        {
          y: "0",
        },
        {
          y: "-40vh",
        }, '<'
      )

    // testing
    // .fromTo(
    //   ".hero-right-img",
    //   {
    //     transformOrigin: 'bottom right',
    //     scale: 1,
    //     // bottom: "-8rem",


    //   },
    //   {
    //     paddingBottom: 0,
    //     bottom:0,
    //     // right: 0,
    //     duration: 0.2,


    //   },
    //   '-=0.1'
    // )

    // .to(
    //   ".js-hero-wrapper .hero-right-img .masked",
    //   {
    //     // transformOrigin: 'bottom right',
    //     width: "100vw",
    //     height: "100vh",
    //     borderTopRightRadius:0,
    //     borderTopLeftRadius: 0,
    //     duration: 0.4,
    //   },

    //   '<'
    // ) 
    //       if(window.matchMedia(`(min-width: ${vpTablet991}px)`).matches){



    if (!isRTL) {
      landingTl.fromTo(
        ".js-hero-wrapper .hero-right-img.js-hero-right-img",
        {
          transformOrigin: 'bottom right',
          scale: 1,
          // bottom: 0,
        },
        {
          paddingBottom: 0,
          right: 0,
          bottom: 0,
          duration: 0.5,

        },
        '-=0.2'
      )

      landingTl.to(
        ".js-hero-wrapper .hero-right-img.js-hero-right-img .masked",
        {
          width: "100vw",
          height: "100vh",
          borderTopRightRadius: 0,
          borderTopLeftRadius: 0,
          duration: 0.5,
        },

        '<'
      );
      setTimeout(() => {
        landingTl.to(".js-hero-wrapper .hero-right-img.js-hero-right-img video", {
          borderTopLeftRadius: 0,
          delay: -0.5,
        }, '<')
      }, 300)

      landingTl.to(".js-hero-wrapper .hero-right-img.js-hero-right-img video", {
        opacity: 1,
        duration: 0.5
      })

        ;


    }
    else {
      landingTl.fromTo(
        ".js-hero-wrapper .hero-right-img.js-hero-right-img",
        {
          transformOrigin: 'bottom left',
          scale: 1,
        },
        {
          paddingBottom: 0,
          left: 0,
          bottom: 0,
          duration: 0.5,


        },
        '-=0.35'
      )

      landingTl.to(
        ".js-hero-wrapper .hero-right-img.js-hero-right-img .masked",
        {
          width: "100vw",
          height: "100vh",
          borderTopRightRadius: 0,
          borderTopLeftRadius: 0,
          duration: 0.5,
        },

        '<'
      )
      setTimeout(() => {
        landingTl.to(".js-hero-wrapper .hero-right-img.js-hero-right-img video", {
          borderTopRightRadius: 0,
          delay: -0.5,
        }, '<')
      }, 300)


      landingTl.to(".js-hero-wrapper .hero-right-img.js-hero-right-img .masked, .js-hero-wrapper .hero-right-img.js-hero-right-img video", {
        opacity: 1,
        duration: 0.5

      });
    }


  });

  // mm.add(
  //   `(min-width: ${vpMobile600 + 1}px) and (max-width: ${vpTablet767}px)`,
  //   () => {
  //     const initialScreenHeight = 1080;

  //     function adjustHeroScrollUp(currentScreenHeight) {
  //       return (500 / initialScreenHeight) * currentScreenHeight;
  //     }

  //     const currentScreenHeight = window.innerHeight;

  //     heroScrollUp = adjustHeroScrollUp(currentScreenHeight);
  //     const landingWrapper = document.querySelector(".js-hero-wrapper");
  //     const landingTl = gsap.timeline({
  //       scrollTrigger: {
  //         trigger: landingWrapper,
  //         pin: true,
  //         scrub: 2,
  //         start: "top top",
  //         invalidateOnRefresh: true,


  //       },
  //     });


  //     gsap.fromTo(
  //       ".js-hero-bg-img",
  //       { scale: 1.2, y: "3rem" },
  //       {
  //         y: "0rem",
  //         duration: 0.2,
  //         scrollTrigger: {
  //           trigger: ".js-hero-bg-img-container",
  //           start: "top top",
  //           end: "bottom bottom",
  //           scrub: 2,
  //         },
  //       }
  //     );
  //     landingTl
  //       .fromTo(
  //         ".js-hero-wrapper .js-hero-title",
  //         {
  //           scale: 1.4,
  //           transformOrigin: isRTL ? 'right bottom' : "left bottom",
  //           y: "40vh",
  //         },
  //         {
  //           scale: 1,
  //           y: "0",
  //           duration: 0.3,
  //         }
  //       )
  //       .fromTo(
  //         ".js-hero-wrapper .js-hero-description-text",
  //         {
  //           y: "100vh",
  //         },
  //         {
  //           y: "0",
  //         },
  //         "<"
  //       )
  //       // .fromTo(
  //       //   ".js-hero-wrapper .js-hero-right-img",
  //       //   {
  //       //     y: "100vh",
  //       //   },
  //       //   {
  //       //     y: "0vh",
  //       //   },
  //       //   "<"
  //       // )

  //       .to(".js-hero-wrapper .js-hero-title", {
  //         y: "-50vh",
  //       })
  //       .fromTo(
  //         ".js-hero-wrapper .js-hero-description-text",
  //         {
  //           y: "0",
  //         },
  //         {
  //           y: "-40vh",
  //         },
  //         "<"
  //       )
  //       .to(
  //         ".js-hero-wrapper .js-scroll_down_cta",
  //         {
  //           opacity: 0,
  //         },
  //         "<"
  //       )

  //       .to(
  //         ".js-hero-wrapper .js-hero-right-img",
  //         {
  //           bottom: 0,
  //           [isRTL ? "left" : "right"]: "0",
  //         },
  //         "<"
  //       );
  //   }
  // );

  mm.add(`(min-width: ${vpTablet767 + .98}px) and (max-width: ${vpTablet991 + .98}px)`, () => { // phone landscape and ipad
    const landingWrapper = document.querySelector(".js-hero-wrapper");
    const landingTl = gsap.timeline({
      scrollTrigger: {
        trigger: landingWrapper,
        pin: true,
        scrub: 2,
        start: "top top",
        invalidateOnRefresh: true,
      },
    });


    if (!isRTL) {
      if (!isPortrait) {
        landingTl.fromTo(
          ".hero-right-img",
          {
            transformOrigin: 'bottom right',
            scale: 1,
            bottom: "-8rem",


          },
          {
            paddingBottom: 0,
            bottom: "-12rem",
            right: 0,
            scale: 1.15,
            duration: 0.2,
          },
          '-=0.1'
        )
      }
      else {
        landingTl.fromTo(
          ".hero-right-img",
          {
            transformOrigin: 'bottom right',
            scale: 1,
            bottom: "15rem",


          },
          {
            paddingBottom: 0,
            bottom: -30,
            right: 0,
            scale: 1.15,
            duration: 0.2,
          },
          '-=0.1'
        )
      }


    } else {
      if (!isPortrait) {
        landingTl.fromTo(
          ".hero-right-img",
          {
            transformOrigin: 'bottom right',
            scale: 1,
            bottom: "-8rem",


          },
          {
            paddingBottom: 0,
            bottom: "-12rem",
            left: 0,
            scale: 1.15,
            duration: 0.2,
          },
          '-=0.1'
        )
      } else {
        landingTl.fromTo(
          ".hero-right-img",
          {
            transformOrigin: 'bottom right',
            scale: 1,
            bottom: "15rem",


          },
          {
            paddingBottom: 0,
            bottom: -30,
            left: 0,
            scale: 1.15,
            duration: 0.2,
          },
          '-=0.1'
        )
      }

    }


    landingTl.to(
      ".js-hero-wrapper .hero-right-img .masked",
      {
        // transformOrigin: 'bottom right',
        width: "100vw",
        height: "100vh",
        borderTopRightRadius: 0,
        borderTopLeftRadius: 0,
        duration: 0.4,
      },

      '<'
    )
  })

  // mobile video
  mm.add(`(max-width: ${vpTablet767}px)`, () => {
    const landingWrapper = document.querySelector(".js-hero-wrapper");
    const landingTl = gsap.timeline({
      scrollTrigger: {
        trigger: landingWrapper,
        pin: true,
        scrub: true,
        start: "top top",

      },
    });

    landingTl


      .fromTo(
        ".hero-right-mob-img",
        {
          transformOrigin: 'bottom right',
          scale: 1,
          bottom: "-8rem",


        },
        {
          // paddingBottom: 0,
          // bottom:0,
          // right: 0,
          scale: 1.15,
          // duration: 0.2,


        },
        '-=0.1'
      )

      .to(
        ".js-hero-wrapper .hero-right-mob-img .masked-mob",
        {
          // transformOrigin: 'bottom right',
          width: "100vw",
          height: "100vh",
          borderTopRightRadius: 0,
          borderTopLeftRadius: 0,
          // duration: 0.4,
        },

        '<'
      )

  });

}

let fadeAnimStarts = false;
// Statement Section Animation
function statementSectionAnim(section, i) {
  let mm = gsap.matchMedia();

  mm.add(`(min-width: ${vpTablet1200}px)`, () => {
    if (!isPortrait) {

      // const statementSections = document.querySelectorAll('.js-statement-section')
      const statementSec = section;


      // statementSections.forEach(statementSec => {

      const statementTl = gsap.timeline({
        scrollTrigger: {
          trigger: statementSec,
          pin: true,
          scrub: 1,
          // end: () => "+=" + $(".container--custom ").outerWidth() ,
          end: "+=300%",
          // end: window.matchMedia(`(max-width: ${vpTablet991}px)`).matches ?  "+=350%" : "+=400%",
          anticipatePin: window.matchMedia(`(max-width: ${vpTablet991}px)`).matches ? 1 : 0,
          onLeaveBack: () => {
            if (i !== 0) {

              document.body.classList.add('bgWhite')
            }

          },

        },
      });


      const topHeading = statementSec.querySelector('.js-statement-section-flex-left-top-heading');
      let topHeadingHeight = topHeading.clientHeight;

      // Get the computed style of the root element to determine the base font size
      const computedStyle = getComputedStyle(document.documentElement);
      const baseFontSizePx = parseFloat(computedStyle.fontSize); // Get the base font size in pixels

      // Convert pixels to rems using the dynamic base font size
      const topHeadingHeightRem = topHeadingHeight / baseFontSizePx;
      if (window.matchMedia(`(max-width: ${vpTablet1200}px)`).matches) {
        statementTl.fromTo(
          statementSec.querySelector(".js-statement-section-flex-left-top-heading-wrapper"),
          {
            opacity: 0,
            duration: 0.01

          }, {
          opacity: 1,
          duration: 0.01
        })
      }
      statementTl

        .fromTo(
          statementSec.querySelector(".js-statement-section-flex-left-top-heading-wrapper"),
          {
            y: "65vh",
            scale: 1.8,
            transformOrigin: isRTL ? 'right bottom' : "left bottom",

          },
          {
            y: "12.75rem",
            scale: .9,
            force3D: true,
            onStart: () => {

              document.body.classList.remove('bgWhite');

            }
          },
          '<0.1'
        )

        .fromTo(
          statementSec.querySelector(".js-statement-section-flex-right-img"),

          {
            y: "100vh",
          },
          {
            y: "-160vh",
            duration: '0.8',
            onStart: () => {
              document.body.classList.remove('bgWhite');
            },
          },
          // "<" before
          "<+=0.2"
        )

        .fromTo(
          statementSec.querySelector(".js-statement-section-flex-left-top-description"),

          {
            y: "100vh",

          },
          {
            y: `${11.75 + 5.625 + topHeadingHeightRem}rem`,
            duration: 0.3,
          }, '>-0.6'
        )


        .fromTo(
          statementSec.querySelector(".js-statement-section-flex-right-center"),
          {
            y: "100vh",
          }, {
          y: "-50%",
        }, ">-0.2"
        )
        .fromTo(
          statementSec.querySelector(".js-statement-section-flex-left-bottom"),
          {
            y: "116.5vh",
            top: "50%",
          },
          {
            y: "-50%",
          }, '<+0.1'
        )

        .to(
          statementSec.querySelectorAll(".js-statement-section-flex-left-top-heading-wrapper, .js-statement-section-flex-left-top-description"),
          {
            y: "-110vh",

            onStart: () => {
              document.body.classList.add('bgWhite')
            },
            onReverseComplete: () => {
              document.body.classList.remove('bgWhite')

            },
          }, '<+0.1'
        )




        .to(
          statementSec.querySelector(".js-statement-section-flex-right-center")
          , {
            y: "-70%",
            duration: 0.2
          }, '<+0.3');
      // })
    }


  })


  // })
}

//  ===========================  Horizontal Section ====================

function generalHorizontalSection(sectionSelector) {
  let mm = gsap.matchMedia();
  const section = $(sectionSelector);
  const tileid = section.find(".tile1");
  const tileid3 = section.find(".tile3")



  const topHeading = section.find('.headingWrap')[0];
  const imgPattern = section.find(".imgPattern")[0];
  const horizontalDetail = section.find(".horizontalDetail");
  const textBaseDetail = section.find('.textBaseDetail')[0];
  const paraWrap = section.find('.paraWrap')[0];
  const quotes = section.find(".js-quote-figure-container");


  // If all <p> elements are empty, add 'display: none' to the .paraWrap

  document.querySelectorAll('.paraWrap').forEach(function (paraWrap) {
    const paragraphs = paraWrap.querySelectorAll('p');
    const areAllEmpty = Array.from(paragraphs).every(paragraph => paragraph.textContent.trim() === '');
    if (areAllEmpty) {
      paraWrap.style.display = 'none';
    }
  });



  if (horizontalDetail.length === 0) {
    console.error("The .horizontalDetail element was not found in the DOM.");
    return;
  }
  mm.add(`(max-width: ${vpTablet991}px)`, () => {
    document.body.classList.remove('bgWhite')
  })

  mm.add(`(min-width: ${vpTablet1200}px)`, () => {

    if (!isPortrait) {
      if (section) {

        let totalWidth = 0;
        horizontalDetail.children('.tileWrapper').each(function () {
          totalWidth += $(this).outerWidth(true);
        });

        horizontalDetail.css({
          width: `${totalWidth}px`,
          overflow: 'hidden',
        });

        const tw1 = gsap.timeline({
          ease: "none",
          scrollTrigger: {
            trigger: tileid,
            scrub: 1,
            start: "top top",
            end: () => "+=" + section.outerWidth(),
            anticipatePin: window.matchMedia(`(max-width: ${vpTablet991}px)`).matches ? 1 : 0,
            onStart: () => {
              document.body.classList.remove('bgWhite')
            },
          },
        });

        if (topHeading) {
          tw1.fromTo(
            topHeading,
            {
              y: "60vh",
              scale: 1.8,
              transformOrigin: isRTL ? 'right bottom' : "left bottom",

            },
            {
              y: "2.75rem",
              scale: .9,
              duration: 5,
              force3D: true,
              onStart: () => {
                document.body.classList.remove('bgWhite');
              },
            },
          )
        }

        if (imgPattern) {
          tw1.fromTo(
            imgPattern,
            {
              // y: "100vh",
              x: isRTL ? "-100vh" : "100vh"
            },
            {
              // y: "4rem",
              x: isRTL ? "0" : "0",
              duration: 5,
              onStart: () => {
                document.body.classList.remove('bgWhite');
              },

              onReverseComplete: () => {
                document.body.classList.remove('bgWhite')

              },
            },
            "<-=0.1"
          )
        }




        // Timeline for the second animation
        const tw3 = gsap.timeline({
          ease: "none",
          scrollTrigger: {
            trigger: tileid3,
            scrub: 0,
            start: () =>
              "top top-=" +
              (totalWidth - window.innerWidth),
            end: () => "+=" + tileid3.offsetWidth,
            anticipatePin: window.matchMedia(`(max-width: ${vpTablet991}px)`).matches ? 1 : 0,
            onStart: () => {
              document.body.classList.add('bgWhite');
            },
            onReverseComplete: () => {
              document.body.classList.remove('bgWhite');
            },
          },
        });

        if (textBaseDetail) {
          tw3.to(
            textBaseDetail,
            {

              duration: .25,
              delay: 1,
              ease: "none",
              // transformOrigin: isRTL ? 'right bottom' : "left bottom",
              onStart: () => {
                gsap.delayedCall(0.5, () => {
                  document.body.classList.add('bgWhite');
                });
              },
              onReverseComplete: () => {
                document.body.classList.remove('bgWhite')

              },


            },
            // "<0.1"
          )
        }


        const tl = gsap.timeline({
          ease: "none",
          scrollTrigger: {
            trigger: section,
            pin: true,
            scrub: 1,
            start: "top top",
            end: () => "+=" + totalWidth,
            anticipatePin: window.matchMedia(`(max-width: ${vpTablet991}px)`).matches ? 1 : 0,
            onStart: () => {
              document.body.classList.remove('bgWhite')
            },
          },
        });


        let topHeadingHeight = topHeading.clientHeight;
        const computedStyle = getComputedStyle(document.documentElement);
        const baseFontSizePx = parseFloat(computedStyle.fontSize);
        const topHeadingHeightRem = topHeadingHeight / baseFontSizePx;



        // Adjust x translation for RTL
        const xEndValue = isRTL
          ? `+${totalWidth - horizontalDetail.parent().width()}px`
          : `-${totalWidth - horizontalDetail.parent().width()}px`;




        tl
          .fromTo(
            horizontalDetail,
            {
              x: "0",

            },
            {
              x: xEndValue,
              ease: "none",
              duration: 3,

              onReverseComplete: () => {
                document.body.classList.remove('bgWhite')

              },
            },
            "<+=2"
          )



      }
    }
  });


}

// Statement Section Animation
function statementSectionAltAnim(section) {
  const statementSec = section;
  const topHeading = statementSec.querySelector('.js-statement-section-flex-left-top-heading');
  let topHeadingHeight = topHeading.clientHeight;
  const computedStyle = getComputedStyle(document.documentElement);
  const baseFontSizePx = parseFloat(computedStyle.fontSize);
  const topHeadingHeightRem = topHeadingHeight / baseFontSizePx;
  const rightCenterElement = statementSec.querySelector(".js-statement-section-flex-right-center");


  const headingWrapper = statementSec.querySelector(".js-statement-section-flex-left-top-heading-wrapper");
  // const rightImg = statementSec.querySelector(".js-statement-section-flex-right-img");
  // const topDescription = statementSec.querySelector(".js-statement-section-flex-left-top-description");
  // const leftBottom = statementSec.querySelector(".js-statement-section-flex-left-bottom");
  // const rightQuote = statementSec.querySelector(".js-flex-right-qoute");
  // const quoteContainer = statementSec.querySelector(".js-quote-figure-container");

  let mm = gsap.matchMedia();
  mm.add(`(min-width: ${vpTablet1200}px)`, () => {
    if (!isPortrait) {
      if (statementSec) {
        const statementTl = gsap.timeline({
          scrollTrigger: {
            trigger: statementSec,
            pin: true,
            scrub: 1,
            end: "+=300%",
            anticipatePin: window.matchMedia(`(max-width: ${vpTablet991}px)`).matches ? 1 : 0,

            onLeaveBack: () => {
              document.body.classList.add('bgWhite')

            },
          },
        });

        if (window.matchMedia(`(max-width: ${vpTablet1200}px)`).matches) {

          if (headingWrapper) {
            statementTl.fromTo(headingWrapper, {
              opacity: 0,
            }, {
              opacity: 1,
              duration: 0.01,
            });
          }
        }
        if (headingWrapper) {
          statementTl.fromTo(headingWrapper, {
            y: "65vh",
            scale: 1.8,
            transformOrigin: isRTL ? 'right bottom' : "left bottom",
          }, {
            y: "12.75rem",
            scale: 1,
            onStart: () => {
              document.body.classList.remove('bgWhite');
            },
          });
        }
        statementTl.fromTo(
          statementSec.querySelector(".js-statement-section-flex-right-img"),

          {
            y: "105vh",
          },
          {
            y: "-160vh",
            duration: '1',
            onStart: () => {
              document.body.classList.remove('bgWhite');
            },

          },
          "<+=0.4"
        )
          .fromTo(
            statementSec.querySelector(".js-statement-section-flex-left-top-description"),
            // statementSec.querySelector(".statementTxtWrap"),

            {
              y: "105vh",
              // opacity: 0
            },
            {
              y: `${11.75 + 5.625 + topHeadingHeightRem}rem`,
              // opacity:1

            },
            "<+=0.1"
          )

        //   statementSec.querySelector(".js-statement-section-flex-right-img"),

        //   {
        //     y: "-160vh",
        //     duration: 0.7,
        //   }
        // )

        // if (rightCenterElement) {

        if (rightCenterElement) {
          statementTl.fromTo(
            rightCenterElement,
            {
              y: "100vh",
            },
            {
              y: "-80vh",
              duration: 1,
            },
            "<+=0.4"
          )
        }



        statementTl.fromTo(
          statementSec.querySelector(".js-statement-section-flex-left-bottom"),
          {
            y: "116.5vh",
            top: "50%",
          },
          {
            y: "-50%",
            onReverseComplete: () => {
              document.body.classList.remove('bgWhite')

            },
            onStart: () => {
              gsap.delayedCall(0.5, () => {
                document.body.classList.add('bgWhite');
              });
            },
          },
          "<+=0.4"
        )
          .to(
            statementSec.querySelectorAll(".js-statement-section-flex-left-top-heading-wrapper, .js-statement-section-flex-left-top-description"),
            {
              y: "-110vh",

            },
            '<+0.1'
          )



          .fromTo(
            statementSec.querySelector(".js-flex-right-qoute")
            , {
              y: "100vh",
            }, {
            y: "-50%",
          }


            , "<")
          .fromTo(
            statementSec.querySelector(".js-quote-figure-container"),
            {
              scale: 0.51,
              transformOrigin: isRTL ? 'right' : "left",

            }, {
            scale: 1,
          }, '<'
          )

          .to(
            statementSec.querySelector(".js-flex-right-qoute")
            , {
              y: "-100%",
              duration: 0.5,


            }, '<+0.5');

      }
    }
  })

}

// Statement Section Animation
function statementSectionBusinessAltAnim(section) {

  let mm = gsap.matchMedia();
  mm.add(`(min-width: ${vpTablet767}px)`, () => {
    // const statementSections = document.querySelectorAll('.js-statement-section-alt.js-business')

    // statementSections.forEach(statementSec => {
    const statementSec = section;

    const statementTl = gsap.timeline({
      scrollTrigger: {
        trigger: statementSec,
        pin: true,
        scrub: 0.75,
        end: "+=300%",

      },
    });

    const topHeading = statementSec.querySelector('.js-statement-section-flex-left-top-heading');
    let topHeadingHeight = topHeading?.clientHeight;

    // Get the computed style of the root element to determine the base font size
    const computedStyle = getComputedStyle(document.documentElement);
    const baseFontSizePx = parseFloat(computedStyle.fontSize); // Get the base font size in pixels

    // Convert pixels to rems using the dynamic base font size
    const topHeadingHeightRem = topHeadingHeight / baseFontSizePx;

    statementTl
      .fromTo(
        statementSec.querySelector(".js-statement-section-flex-left-top-heading"),
        {
          y: "90vh",
          scale: 1.2,
          transformOrigin: isRTL ? 'right bottom' : "left bottom",

        },
        {
          y: "12.75rem",
          scale: 1,
          onStart: () => {
            document.body.classList.remove('bgWhite');
          },
        }
      )
      .fromTo(
        statementSec.querySelector(".js-statement-section-flex-right-img"),

        {
          y: "100vh",
        },
        {
          y: "10vh",
          onStart: () => {
            document.body.classList.remove('bgWhite');
          },
        },
        "-=0.2"
      )
      .fromTo(
        statementSec.querySelector(".js-statement-section-flex-left-top-description"),

        {
          y: "100vh",
        },
        {
          y: `${12.75 + 5.625 + 4.375 + topHeadingHeightRem}rem`,
        },
        "<"
      )
      .to(
        statementSec.querySelectorAll(".js-statement-section-flex-left-top-heading, .js-statement-section-flex-left-top-description"),
        {
          y: "-110vh",
        }
      )
      .fromTo(
        statementSec.querySelector(".js-statement-section-flex-right-center"),
        {
          y: "100vh",

        }, {
        y: "11.6875rem",
      },
        '<'
      )
      .fromTo(
        statementSec.querySelector(".js-statement-section-flex-left-bottom"),
        {
          y: "116.5vh",
          top: "50%",
        },
        {
          y: "-50%",
        }, '-=0.3'
      )
      .to(
        statementSec.querySelector(".js-statement-section-flex-right-center")
        , {
          y: "-80vh",
        }
        , '-=0.1'
      )

      .fromTo(
        statementSec.querySelector(".js-flex-right-qoute")
        , {
          y: "100vh",
        }, {
        y: "-50%",

      }, '<')
      .fromTo(
        statementSec.querySelector(".js-quote-figure-container"),
        {
          scale: 0.51,
          transformOrigin: isRTL ? 'right bottom' : "left bottom",

        }, {
        scale: 1,
      }, '<'
      )
      .to(
        statementSec.querySelectorAll(".js-statement-section-flex-left-bottom, .js-flex-right-qoute"),

        {
          top: 0,
          y: "-120%",
          opacity: 0,
        }
      )
      .fromTo(
        statementSec.querySelector(".js-outside-flex-box-bottom")
        , {
          y: "100vh",
        }, {
        y: "0vh",
        onReverseComplete: () => {
          document.body.classList.remove('bgWhite')

        },
      }, "<").to(
        statementSec.querySelector(".js-outside-flex-box-bottom")
        , {
          opacity: 1,

        })
  })
  // })

}

function jsAnimFade() {
  let mm = gsap.matchMedia();

  const jsAnimFades = document.querySelectorAll('.js-anim-fade-dsk');


  jsAnimFades.forEach(jsAnimFade => {
    const animFadeTl = gsap.timeline({
      scrollTrigger: {
        trigger: jsAnimFade,
        start: "top bottom",
      },
    });

    animFadeTl.fromTo(jsAnimFade, {
      y: "30vh",
      opacity: 0
    }, {
      y: "0vh",
      opacity: 1
    })
  })

  mm.add(`(max-width: ${vpTablet991}px)`, () => {
    const jsAnimFades = document.querySelectorAll('.js-anim-fade-tab');

    jsAnimFades.forEach(jsAnimFade => {

      const animFadeTl = gsap.timeline({
        scrollTrigger: {
          trigger: jsAnimFade,
          start: "top bottom",

        },
        onComplete: () => { ScrollTrigger.refresh(true); }
      });

      animFadeTl.fromTo(jsAnimFade, {
        y: "30vh",
        opacity: 0,
        duration: .5
      }, {
        y: "0vh",
        opacity: 1,
      })
    })
  })
  mm.add(`(max-width: ${vpTablet1200}px)`, () => {
    const jsAnimFades = document.querySelectorAll('.js-anim-fade-tab-1220');

    jsAnimFades.forEach(jsAnimFade => {

      const animFadeTl = gsap.timeline({
        scrollTrigger: {
          trigger: jsAnimFade,
          start: "top bottom",

        },
        onComplete: () => { ScrollTrigger.refresh(true); }
      });

      animFadeTl.fromTo(jsAnimFade, {
        y: "30vh",
        opacity: 0
      }, {
        y: "0vh",
        opacity: 1
      })
    })
  })

  mm.add(`(max-width: ${vpTablet767}px)`, () => {
    const jsAnimFades = document.querySelectorAll('.js-anim-fade');

    jsAnimFades.forEach(jsAnimFade => {

      const animFadeTl = gsap.timeline({
        scrollTrigger: {
          trigger: jsAnimFade,
          start: "top bottom",

        },
        onComplete: () => { ScrollTrigger.refresh(true); }
      });

      animFadeTl.fromTo(jsAnimFade, {
        y: "30vh",
        opacity: 0
      }, {
        y: "0vh",
        opacity: 1
      })
    })
  })

}

// Check which language is active
function checkActiveLanguage() {
  if (isRTL) {
    $('#js-lang-ar').addClass('active')
    $('#js-mobile-lang-ar').addClass('active')
  } else {
    $('#js-lang-en').addClass('active')
    $('#js-mobile-lang-en').addClass('active')
  }
}

let heroScrollUp;
// Footer scroll to top button
function scrollTop() {
  let mm = gsap.matchMedia();
  $('#js-scroll-top').on('click', function () {
    $('html, body').animate({ scrollTop: heroScrollUp }, 'slow');
    $('html, body').animate({ scrollTop: -1 }, 'slow');
  });
  mm.add(`(max-width: ${vpTablet767}px)`, () => {
    $('#js-scroll-top').on('click', function () {
      $('html, body').animate({ scrollTop: -1 }, 'slow');
    });
  })
}
function scrollToTopOnLoad() {
  $('html, body').animate({ scrollTop: 0 }, 'fast');
}

const openAndCloseStatmentDrawer = () => {
  const statementSections = document.querySelectorAll('.js-statement-section-main')
  const drawers = document.querySelectorAll('.js-statement-drawer')
  statementSections?.forEach(section => {
    // const drawer = section?.nextElementSibling;
    const sectionUid = section.getAttribute('data-sectionid')


    let readStatementCtas;
    readStatementCtas = section?.querySelectorAll('.js-read-statement-cta')
    // const closeCtas = drawer?.querySelectorAll('.js-close-ic')

    // if (window.matchMedia(`(min-width: ${vpTablet767}px)`).matches && !isPortrait) {
    //   readStatementCtas = section?.querySelectorAll('.js-read-statement-cta')
    // }
    //  else {
    //   readStatementCtas = section?.querySelectorAll('.js-read-statement-cta-mob')
    // }
    const smoother = ScrollSmoother.get();
    readStatementCtas.forEach(readStatementCta => {

      readStatementCta?.addEventListener('click', () => {


        drawers.forEach(drawer => {

          const drawerUid = drawer.getAttribute('data-sectionid')

          if (sectionUid === drawerUid) {
            drawer?.classList.add('drawer--open')
            document.body?.classList.add("scrollHide")
            if (smoother) {

              smoother.paused(true);
            }
          }
        })


      })
    })
    drawers.forEach(drawer => {

      const closeCtas = drawer?.querySelectorAll('.js-close-ic')
      const drawerUid = drawer.getAttribute('data-sectionid');
      const backDropBg = drawer?.querySelector('.backdropBG');
      closeCtas?.forEach(closeCta => {

        closeCta?.addEventListener('click', () => {
          if (sectionUid === drawerUid) {
            drawer?.classList.remove('drawer--open')
            document.body?.classList.remove("scrollHide")
            if (smoother) {

              smoother.paused(false);
            }

          }

        })

        backDropBg?.addEventListener('click', () => {
          if (sectionUid === drawerUid) {
            drawer?.classList.remove('drawer--open')
            document.body?.classList.remove("scrollHide")
            if (smoother) {

              smoother.paused(false);
            }

          }
        })

        $(document).keydown(function (e) {

          if (e.keyCode == 27) {
            if (sectionUid === drawerUid) {
              drawer?.classList.remove('drawer--open')
              document.body?.classList.remove("scrollHide")
              if (smoother) {

                smoother.paused(false);
              }

            }
          }
        });

      })

    })
  })

}

function addNavLinksEvents() {
  const sections = document.getElementsByClassName('js-go-to-nav-section');
  // For header color change (Was an issue in last)
  const sectionsHeaders = document.getElementsByClassName('js-header-variant');
  const navMobItems = document.querySelectorAll('.js-nav-item');
  const timelines = document.getElementsByClassName('timelines');
  const sectionsArray = [...sections];
  const timelinesArray = [...timelines];
  const sectionsHeadersArray = [...sectionsHeaders];

  if (window.matchMedia(`(max-width: ${vpMobile600}px)`).matches) {
    navMobItems.forEach((timeline, i) => {
      timeline.addEventListener('click', function (e) {
        navMobItems.forEach((timeline, j) => {
          timeline?.classList.remove('active');
        });

        const targetAttr = e.currentTarget.getAttribute('data-sectionid');

        sectionsArray.forEach(section => {
          const secAttr = section?.getAttribute('data-sectionid')

          if (secAttr === targetAttr) {
            gsap.to(window, { duration: 1.5, scrollTo: { y: section, offsetY: secAttr === 'timelineScroll' ? 0 : -80 } });
          }
        })
      });
    })

  } else {
    timelinesArray.forEach((timeline, i) => {
      timeline.addEventListener('click', function (e) {
        // Remove the 'active' class from all timelines
        timelinesArray.forEach((timeline, j) => {
          timeline?.classList.remove('active');
        });

        const targetAttr = e.currentTarget.getAttribute('data-sectionid');

        sectionsArray.forEach(section => {
          const secAttr = section.getAttribute('data-sectionid');

          if (secAttr === targetAttr) {


            // Scroll to the section start
            gsap.to(window, {
              duration: 1.5,
              scrollTo: {
                y: section,
                offsetY: secAttr === 'timelineScroll' ? -3 : -15,
              },

            });
          }
        });
      });
    });

  }

  const navSections = document.getElementsByClassName('js-nav-section');
  const navSectionsArray = [...navSections];

  const mainTextContainerObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry, i) => {
      if (entry.isIntersecting) {
        const sectionIdx = navSectionsArray.indexOf(entry.target);
        intersectingSection = entry.target;
        const dataId = intersectingSection.getAttribute('data-sectionId');

        if (window.matchMedia(`(max-width: ${vpMobile600}px)`).matches) {
          // navMobItems.forEach((timeline, i) => {
          //   timeline.classList.remove('active');
          // });
          // navMobItems[sectionIdx]?.classList.add('active');


          navMobItems.forEach((timeline, j) => {
            const timelineDataId = timeline.getAttribute('data-sectionId')

            if (dataId === timelineDataId) {
              navMobItems.forEach((timeline, j) => {
                timeline.classList.remove('active')
              })
              timeline.classList.add('active');

            }
          });

        } else {

          timelinesArray.forEach((timeline, j) => {
            const timelineDataId = timeline?.getAttribute('data-sectionId')

            if (dataId === timelineDataId) {
              timelinesArray.forEach((timeline, j) => {
                timeline?.classList.remove('active')
                timeline?.classList.remove('hover')
              })
              setTimeout(() => {
                timeline?.classList.add('hover');
              }, 1000)

              timeline?.classList.add('active');
              setTimeout(() => {
                timeline?.classList.remove('hover');
              }, 5000)
            }
          });



        }

        // let isSectionDark = $(sectionsArray[sectionIdx]).hasClass('dark');
        // if (isSectionDark) {
        //   $('#js-header-wrapper').addClass('dark');
        //   $('.js-section-timeline-wrapper').addClass('dark');
        // } else {
        //   $('#js-header-wrapper').removeClass('dark');
        //   $('.js-section-timeline-wrapper').removeClass('dark');
        // }

      }
    });
  }, { rootMargin: "0% 0px -90% 0px", threshold: 0 });


  navSectionsArray.forEach((section, i) => {
    mainTextContainerObserver.observe(section);
  });
  // For header color change (Was an issue in last)
  const headerContainerObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry, i) => {
      if (entry.isIntersecting) {

        const sectionIdx = sectionsHeadersArray.indexOf(entry.target);

        let isSectionDark = $(sectionsHeadersArray[sectionIdx]).hasClass('dark');
        const currentSection = sectionsHeadersArray[sectionIdx];

        if (isSectionDark) {
          $('#js-header-wrapper').addClass('dark');
          $('.js-section-timeline-wrapper').addClass('dark');
        } else {
          $('#js-header-wrapper').removeClass('dark');
          $('.js-section-timeline-wrapper').removeClass('dark');
        }

        const sectionId = $(currentSection).data('sectionid');
        if (sectionId === 'impact1' || sectionId === 'impact2' || sectionId === 'impact4' || sectionId === 'impact') {
          $('#js-header-wrapper').addClass('darkSec');
          $('.js-section-timeline-wrapper').addClass('darkSec');
        } else {
          $('#js-header-wrapper').removeClass('darkSec');
          $('.js-section-timeline-wrapper').removeClass('darkSec');
        }

      }
    });
  }, { rootMargin: "0% 0px -98% 0px", threshold: 0 });


  sectionsHeadersArray.forEach((section, i) => {
    headerContainerObserver.observe(section);
  });

}

// function lazyLoadingFunc(){
//   const lazyVideos = document.querySelectorAll(".lazy-video");
//   videoElement.load();
//   console.log({lazyVideos})
//   const videoObserver = new IntersectionObserver((entries, observer) => {
//     entries.forEach(entry => {
//       if (entry.isIntersecting) {
//         const video = entry.target;
//         const sources = video.querySelectorAll('source');

//         sources.forEach(source => {
//           source.src = source.dataset.src;
//         });

//         video.load(); // Start loading the video
//         video.classList.add("lazyloaded");
//         observer.unobserve(video); // Stop observing once loaded
//       }
//     });
//   });

//   lazyVideos.forEach(video => {
//     videoObserver.observe(video);
//   });
// }

function impactSectionAnimation(section) {
  let mm = gsap.matchMedia();
  mm.add(`(min-width: ${vpTablet767}px)`, () => {
    // const impactSections = document.querySelectorAll('.js-impact-section')
    const impactSection = section
    // impactSections.forEach(impactSection => {
    const textContainer = impactSection.querySelector('.js-text-container')
    const newRightSection = impactSection.querySelector(".js-stats-container");

    const newRightSectionHeight = newRightSection?.clientHeight;


    const impactSectionTimeline = gsap.timeline({
      scrollTrigger: {
        trigger: impactSection,
        start: "top top",
        pin: true,
        end: () => window.matchMedia(`(max-width: ${vpTablet991}px)`).matches ? `${newRightSectionHeight}px` : `${newRightSectionHeight * 1.5}px`,
        pinContainer: textContainer,
        scrub: 1,
        anticipatePin: window.matchMedia(`(max-width: ${vpTablet991}px)`).matches ? 1 : 0

        // onUpdate: (self) => {
        //   gsap.to(rightSection, {
        //     y: `-${window.scrollY - impactSectionTop - window.innerHeight}`,

        //   });
        // },
      },
    });


    impactSectionTimeline.to(
      newRightSection, {
      y: `-100%`,
    }, '')

    // })


  })
  mm.add(`(max-width: ${vpTablet767}px) and (min-width: ${vpMobile600 + 1}px)`, () => {

    const impactSection = section


    const textContainer = impactSection.querySelector('.js-text-container')
    const newRightSection = impactSection.querySelector(".js-stats-container");

    const newRightSectionHeight = newRightSection?.clientHeight;

    const pinTimeline = gsap.timeline({
      scrollTrigger: {
        trigger: impactSection,
        start: "top top",
        pin: true,
        end: () => `${newRightSectionHeight * 2}px`,
        scrub: 0.75,
        anticipatePin: window.matchMedia(`(max-width: ${vpTablet991}px)`).matches ? 1 : 0

      },
    })


    pinTimeline.fromTo(newRightSection, {
      y: `70vh`,

    },
      {
        y: `-80%`,
        duration: 10,
      }, '<');


  })
  mm.add(`(max-width: ${vpMobile600}px)`, () => {


    // const impactSections = document.querySelectorAll('.js-impact-section')

    // const rightSection = $(".js-stats-container");
    // const impactSection = $(".js-impact-section");
    // const rightSectionHeight = rightSection.outerHeight(true);
    // impactSections.forEach(impactSection => {

    const impactSection = section


    const contentContainer = impactSection.querySelector('.js-content-container')
    const newRightSection = impactSection.querySelector(".js-stats-container");

    const newRightSectionHeight = newRightSection?.clientHeight;

    const pinTimeline = gsap.timeline({
      scrollTrigger: {
        trigger: impactSection,
        start: "top top",
        pin: true,
        end: () => `${newRightSectionHeight * 2}px`,
        scrub: 0.75,
        anticipatePin: window.matchMedia(`(max-width: ${vpTablet991}px)`).matches ? 1 : 0
      },
    })

    pinTimeline.fromTo(contentContainer, {
      y: "40vh"
    }, {
      y: '-70%',
      duration: 5,
    })



  })

  // impactSectionTimeline.fromTo(rightSection, {
  //   y: "50vh",
  // }, {
  //   y: "0",
  // })
  // const impactSections = document.querySelectorAll('.js-impact-section')


  // const elements = $(".js-stats-items-container");
  // const elementHeadings = $(".js-section-heading");
  // const textContainers = $(".js-stats-item");

  // const mainTextContainerObserver = new IntersectionObserver((entries) => {
  //   entries.forEach((entry, i) => {
  //     const images = $(".js-impact-bg-img");

  //     if (entry.isIntersecting) {
  //       const intersectingIndex = $(entry.target).index(
  //         ".js-stats-items-container"
  //       );
  //       elementHeadings.each((i, element) => {
  //         $(element).removeClass("active");
  //         if (i === intersectingIndex) {
  //           $(element).addClass("active");
  //         }
  //       });

  //       images.each((i, img) => {
  //         $(img).removeClass("active");

  //         if (i === intersectingIndex) {
  //           $(img).addClass("active");
  //         }
  //       });
  //     }
  //   });
  // }, { rootMargin: "-50% 0px -50% 0px" });

  // const textContainerObserver = new IntersectionObserver(
  //   (entries) => {
  //     entries.forEach((entry) => {
  //       if (entry.isIntersecting) {
  //         const intersectingIndex = $(entry.target).index(
  //           ".js-stats-item"
  //         );
  //         textContainers.each((i, textContainer) => {
  //           $(textContainer).removeClass("active");

  //           if (i === intersectingIndex) {
  //             $(textContainer).addClass("active");
  //           }
  //         });
  //       }
  //     });
  //   },
  //   { rootMargin: "-50% 0px -50% 0px" } // Adjusted threshold values
  // );
  // // Select all elements to observe using a common class

  // // Loop through each element and start observing
  // elements.each((i, element) => {
  //   mainTextContainerObserver.observe(element);
  // });
  // textContainers.each((i, element) => {
  //   textContainerObserver.observe(element);
  // });


  // Select all impact sections
  const impactSections = document.querySelectorAll('.js-impact-section');

  // Loop through each impact section
  impactSections.forEach((section) => {
    // Select elements within the current section
    const elements = section.querySelectorAll('.js-stats-items-container');
    const elementHeadings = section.querySelectorAll('.js-section-heading');
    const textContainers = section.querySelectorAll('.js-stats-item');
    const images = section.querySelectorAll('.js-impact-bg-img');

    // Create IntersectionObservers for the current section
    const mainTextContainerObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {

          const intersectingIndex = Array.from(section.querySelectorAll('.js-stats-items-container')).indexOf(entry.target);

          elementHeadings.forEach((element, i) => {
            element.classList.remove("active");
            if (i === intersectingIndex) {
              element.classList.add("active");
            }
          });

          images.forEach((img, i) => {
            img.classList.remove("active");
            if (i === intersectingIndex) {
              img.classList.add("active");
            }
          });
        }
      });
    }, { rootMargin: "-50% 0px -50% 0px" });

    const textContainerObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const intersectingIndex = Array.from(section.querySelectorAll('.js-stats-item')).indexOf(entry.target);
          textContainers.forEach((textContainer, i) => {
            textContainer.classList.remove("active");
            if (i === intersectingIndex) {
              textContainer.classList.add("active");
            }
          });
        }
      });
    }, { rootMargin: "-50% 0px -50% 0px" });

    // Observe elements within the current section
    elements.forEach(element => {
      mainTextContainerObserver.observe(element);
    });

    textContainers.forEach(element => {
      textContainerObserver.observe(element);
    });
  });
}

function sectionTimelineScroll() {

  const mm = gsap.matchMedia();

  mm.add({
    // Matches screens larger than 768px (not mobile)
    isNotMobile: `(min-width: ${vpTablet991 + 1}px)`,
    // Matches screens 768px and below (mobile)
    isMobile: `(max-width: ${vpTablet991}px)`
  }, (context) => {

    if (context.conditions.isNotMobile) {
      const timelines = document.querySelectorAll('.timeline-scroll-animation');

      if (timelines.length > 0) {
        const firstElement = timelines[0];
        const lastElement = timelines[timelines.length - 1];
        const timelineFirstWidth = firstElement.offsetWidth;
        const timelineTotalElements = timelines.length;

        const baseFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize); // Get the base font size in pixels
        const marginLeft = 10 * baseFontSize;

        const isRTL = document.documentElement.getAttribute('dir') === 'rtl';

        const timelineWidth = (timelineFirstWidth + marginLeft) * (timelineTotalElements - 1);

        gsap.to(".horizontal-scroll-content-timeline", {
          x: isRTL ? timelineWidth : -timelineWidth,
          ease: "none",
          scrollTrigger: {
            end: () => `+=${timelineWidth}`,
            trigger: ".section-timeline-scroll",
            pin: true,
            scrub: 1.5,
            snap: {
              snapTo: (1 / (timelineTotalElements - 1)),
              duration: 1,
              delay: 0.5,
            }
          }
        });

        let lastScrollTop = window.scrollY || document.documentElement.scrollTop;

        window.addEventListener('scroll', () => {
          const currentScrollTop = window.scrollY || document.documentElement.scrollTop;
          const isScrollingDown = currentScrollTop > lastScrollTop;

          timelines.forEach((timeline) => {
            const { left: timelineLeft, right: timelineRight } = timeline.getBoundingClientRect();

            if (isScrollingDown) {
              if ((isRTL && timelineRight > timelineFirstWidth) || (!isRTL && timelineLeft < timelineFirstWidth)) {
                timeline.classList.add('active');
              } else {
                timeline.classList.remove('active');
              }
            } else {
              if ((isRTL && timelineRight < (timelineFirstWidth + 240)) || (!isRTL && timelineRight > (timelineFirstWidth + 240))) {
                timeline.classList.remove('active');
              }
            }
          });
          const skipBtn = document.querySelector('.js-section-timeline-scroll-main .js-btn-flex-left-desktop');

          // Hide the skip button if the last element is active
          if (lastElement.classList.contains('active')) {
            if (skipBtn) {

              gsap.to(skipBtn, {
                opacity: 0,
                pointerEvents: 'none'
              })
            }
          } else {
            if (skipBtn) {
              gsap.to(skipBtn, {
                opacity: 1,
                pointerEvents: 'all'
              })
            }
          }

          lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
        });

        const skipBtn = document.querySelector('.js-section-timeline-scroll-main .js-btn-flex-left-desktop');
        if (skipBtn) {
          skipBtn.addEventListener('click', () => {
            const element = document.querySelector('.js-section-timeline-scroll-main');
            if (element) {
              const nextSibling = element.nextElementSibling;
              if (nextSibling) {
                gsap.to(window, { duration: 2, scrollTo: nextSibling });
              }
            }
          });
        }
      }
    }
    else if (context.conditions.isMobile) {
      const timelines = document.querySelectorAll('.horizontal-scroll-content-timeline');
      if (timelines.length > 0) {
        const firstChild = timelines[0].querySelector('.active');
        if (firstChild) {
          firstChild.classList.remove('active');
        }
      }
      const skipBtn = document.querySelector('.js-section-timeline-scroll-main .js-btn-flex-left')
      skipBtn?.addEventListener('click', () => {
        var element = document.querySelector('.js-section-timeline-scroll-main');
        var nextSibling = element.nextElementSibling;
        gsap.to(window, { duration: 1.5, scrollTo: nextSibling });
      });

    }
  });

}

function removeTimelineOnFooter() {
  let options = {
    root: null,
    rootMargin: '0px',
    threshold: 0
  };

  let observer = new IntersectionObserver((entries, observer) => {
    let element = document.querySelector('.js-section-timeline-wrapper');
    entries.forEach(entry => {
      if (entry.isIntersecting) {

        if (element && loaderAnimCompletes) {
          gsap.to(element, {
            duration: 0.2,
            opacity: 1,
            pointerEvents: 'none'
          })
        }
      } else {
        if (element && loaderAnimCompletes) {
          gsap.to(element, {
            duration: 0.2,
            opacity: 1,
            pointerEvents: 'all'
          })
        }
      }
    });
  }, options);

  let target = document.querySelector('.js-statement-section-alt-6');
  observer.observe(target);
}

function readMoreBtn() {
  let readMoreBtn = $('.read-more-btn');
  if (readMoreBtn.length > 0) {
    if ($(window).width() < 767.98) {


      $('.subTextWrap').each(function () {
        var $content = $(this);
        var $bodyElements = $content.find('.body2'); // Select all .body2 elements (both p and li)
        var maxVisibleItems = 4; // Maximum number of visible items before truncation

        // If there are more than 4 .body2 elements, show "Read More" button and hide the extras
        if ($bodyElements.length > maxVisibleItems) {
          $bodyElements.slice(maxVisibleItems).hide(); // Hide elements after the 4th one
          $content.find('.read-more-btn').show(); // Show the "Read More" button
        } else {
          // If 4 or fewer, hide the "Read More" button
          $content.find('.read-more-btn').hide();
        }

        // "Read More" button click handler
        $content.find('.read-more-btn').on('click', function () {
          setTimeout(() => {
            ScrollTrigger.refresh();
          }, 600);

          $content.toggleClass('showTxt');
          if ($content.hasClass('showTxt')) {
            // Show all items when expanded
            $bodyElements.show();
          } else {
            // Collapse back to showing only the first 4 items
            $bodyElements.slice(maxVisibleItems).hide();
          }

          // Recalculate scroll-based animations
          if (typeof ScrollTrigger !== "undefined") {
            ScrollTrigger.refresh();
          }
        });
      });



    }

  }


  // horizontal text para
  if ($(".paraWrap").length > 0) {
    if ($(window).width() < 767.98) {

      $('.paraWrap').each(function () {
        var $paragraphs = $(this).find('p'); // Find all p elements in the container
        var maxLength = 300; // Maximum character length before truncation

        $paragraphs.each(function () {
          var $para = $(this);
          var originalText = $para.text();

          // Check if paragraph text exceeds the maximum length
          if (originalText.length > maxLength) {
            // Truncate the text for this paragraph
            var truncatedText = originalText.substring(0, maxLength) + '...';
            $para.text(truncatedText);

            // Handle "Read More" button click
            $(this).closest('.paraWrap').find('.read-more-btn').on('click', function () {
              setTimeout(() => {
                ScrollTrigger.refresh();
              }, 600);

              // Restore the full text of all paragraphs in this container
              $paragraphs.each(function () {
                $(this).text($(this).data('original-text')); // Restore original text
              });

              $(this).closest('.paraWrap').addClass('expanded');

              // Recalculate scroll-based animations
              if (typeof ScrollTrigger !== "undefined") {
                ScrollTrigger.refresh();
              }
            });

            // Store the original text for restoring later
            $para.data('original-text', originalText);
          } else {
            // If the text is not too long, hide the button
            $(this).closest('.paraWrap').find('.read-more-btn').hide();
            $(this).closest('.paraWrap').addClass('expanded');
          }
        });
      });

    }
  }

}

// function loadVideoLazy(){
const mobileVideoUrl = '/Pages/assets/videos/annual-report.mp4';
const desktopVideoUrl = '/Pages/assets/videos/annual-report-mob.mp4';
// Function to determine if the device is mobile
function isMobile() {
  return $(window).width() <= 768; // Adjust this value based on your breakpoint
}

// Function to create and append the <source> element for video
function createSource($videoElement, videoUrl) {
  var $source = $('<source>').attr('src', videoUrl).attr('type', 'video/mp4');
  $videoElement.append($source); // Append the <source> element dynamically
  $videoElement[0].load();       // Load the video with the new source
}

// Function to load the appropriate video based on device type
function loadVideo() {
  var $mobileVideo = $('#mask-video-mob');
  var $desktopVideo = $('#mask-video');

  // Remove any existing <source> elements to prevent issues
  $mobileVideo.empty();
  $desktopVideo.empty();

  if ($(window).width() <= 767.98) {
    createSource($mobileVideo, mobileVideoUrl);
    $desktopVideo.hide();    // Hide the desktop video
  } else {
    createSource($desktopVideo, desktopVideoUrl);
    $mobileVideo.hide();     // Hide the mobile video
  }
}

// Run the function on page load
loadVideo();

// Optional: Run the function on window resize to update the video source
$(window).resize(function () {
  loadVideo();
  setTimeout(function () {
    // Recalculate scroll-based animations or other triggers
    ScrollTrigger.refresh(); // For GSAP
  }, 250); // Debounce time
  // setVH();
});
// }


function setVH() {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  ScrollTrigger.refresh();
}

// Call on load and on resize
window.addEventListener('resize', setVH);
setVH();